export default __webpack_public_path__ + "static/media/firstPage.b04d4de1.png";